<template>
  <div class="about-wrapper" v-editable="blok" @show="test()">
    <div class="grid">
      <h1>
        <mark v-in-viewport.once v-html="$forceBreak(blok.Headline)"></mark>
      </h1>
      <div class="about-text-grid">
        <div class="about-text">
          <h3>{{blok.SubHeadlineText}}</h3>
          <p>{{blok.Text}}</p>
        </div>
        <div class="about-contact">
          <h3>{{blok.SubHeadlineContact}}</h3>
          <p>{{blok.Phone}}</p>
          <a
            @click="GA('Mail', 'Click', blok.mail )"
            alt="Send mail to Manyone"
            :href="'mailto:' + blok.mail"
          >
            <p>{{blok.mail}}</p>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["blok"],
  methods: {
    GA: function(category, action, label) {
      this.$ga.event(category, action, label);
    },
    test() {
      console.log("test");
    }
  }
};
</script>

<style lang="scss" scoped>
@import "AppAbout.scss";
</style>